import { Pipe, PipeTransform } from '@angular/core';
import { ItemFeeRow } from '../item-pricing-table-base';

@Pipe({
  name: 'hasSetupFee',
  pure: false,
  standalone: false,
})
export class HasSetupFeePipe implements PipeTransform {
  transform(itemFees: ItemFeeRow[]): boolean {
    return itemFees.some((fee) => fee.type === 'setup');
  }
}
